import { useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * RedirectByDomain Component
 *
 * Questo componente gestisce il reindirizzamento iniziale basato sul dominio o sul path.
 *
 * FUNZIONAMENTO:
 * 1. In `src/app/App.js`, il `basename` del router viene impostato dinamicamente (es. "/valderma" o "/roydermal").
 * 2. Questo componente verifica se l'utente si trova alla radice del sito o se il path è vuoto.
 * 3. Se la condizione è vera, esegue `history.replace("/")`.
 *
 * IMPORTANTE:
 * Poiché il `basename` è già impostato nel Router (in App.js), `history.replace("/")` NON porta alla root del server,
 * ma alla root del basename configurato.
 *
 * Esempio:
 * - Se basename="/valderma", `history.replace("/")` porta a "/valderma/".
 * - Successivamente, `src/app/BasePage.js` intercetta "/" (che è relativo al basename) e reindirizza a "/dashboard".
 * - Risultato finale: L'utente atterra su "/valderma/dashboard".
 */
const RedirectByDomain = () => {
  const history = useHistory();

  useEffect(() => {
    const host = window.location.hostname;
    const pathname = window.location.pathname;

    const parts = pathname.slice(1).split("/");
    let basePath = parts[0];

    if (host === "agenti.epspharma.it") {
      if (pathname === "/" || basePath === "") {
        history.replace("/");
      }
    } else if (host === "agenti.roydermal.it") {
      if (pathname === "/" || basePath === "") {
        history.replace("/");
      }
    } else if (host === "localhost") {
      if (pathname === "/" || basePath === "") {
        history.replace("/");
      }
    }
  }, [history]);

  return null;
};

export default RedirectByDomain;
